import { Context } from '../..';
import * as base from '../base';
import { LearnerCareerPath } from '../../../models/view/learner-career-path';
import { handleErrorToErrorPage } from '../functions';
import { ErrorSignalTypes } from '../../../enums';
import { LearnerCareerPathSkillSet } from '../../../models';

const CONTROLLER = `learnercareerpath`;

export async function getLearnerCareerPaths(context: Context, payload: { companySlug: string; assessmentSlug: string; learnerSlug: string }): Promise<LearnerCareerPath[] | undefined> {
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `${payload.assessmentSlug}${base.params({ companySlug: payload.companySlug, learnerSlug: payload.learnerSlug })}`) };
  const response: base.IResponse<LearnerCareerPath[]> = await base.request(request);
  return response.data;
}

// @Jedidja
export async function saveLearnerCareerPaths(context: Context, payload: LearnerCareerPath[]): Promise<void> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, context.state.activeAssessmentConfig?.assessmentSlug), method: 'POST', body: JSON.stringify(payload) };
  await base.request(request);
}

// @Jedidja
export async function getLearnerCareerPathSkillSets(context: Context): Promise<LearnerCareerPathSkillSet[] | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `skill-sets`, context.state.activeAssessmentConfig?.assessmentSlug) };
  const response: base.IResponse<LearnerCareerPathSkillSet[]> = await base.request(request);

  return response.data;
}

// @Jedidja
export async function saveLearnerCareerPathSkillSets(context: Context, payload: LearnerCareerPathSkillSet): Promise<LearnerCareerPathSkillSet | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `skill-sets`, context.state.activeAssessmentConfig?.assessmentSlug), method: 'POST', body: JSON.stringify(payload) };
  const response: base.IResponse<LearnerCareerPathSkillSet> = await base.request(request);

  return response.data;
}

// @Jedidja
export async function getLearnerCareerPathSkillSet(context: Context, payload: string): Promise<LearnerCareerPathSkillSet | undefined> {
  if (!context.state.activeAssessmentConfig?.assessmentSlug) {
    handleErrorToErrorPage(context, `/error/${ErrorSignalTypes.System}/404`, window.location.pathname);
    return undefined;
  }
  const request: base.IRequest = { url: base.apiURL(CONTROLLER, `skill-sets`, context.state.activeAssessmentConfig?.assessmentSlug, payload), authenticated: true };
  const response: base.IResponse<LearnerCareerPathSkillSet> = await base.request(request);

  return response.data;
}

